<div *ngIf="cardData && (cardType === 'facility' || (cardType === 'job' && cardData.facilityName))" class="side-bar">
  <div class="side-nav">
    <div class="heading-container px-3 py-2 pt-3">
      <a href="javascript:void(0);" (click)="closeSideNavBar()"
        ><img style="height: 12px; width: 12px" src="/assets/images/icon/close.svg"
      /></a>
    </div>
    <div class="sidenav-container">
      <div>
        <p class="heading-title">
          {{ cardData?.owner?.owner_name }} | {{ cardData?.facilityName }}
          <a href="owner_info/add_edit;id={{ cardData?.owner?.id }}" target="_blank"
            ><img src="/assets/images/icon/openFacility.svg"
          /></a>
        </p>
      </div>
      <div>
        <p>
          <a
            href="https://maps.google.com/?q={{ getFacilityAddress() }}"
            target="_blank"
            class="card-link text-dark bold">
            <img src="/assets/images/icon/location.svg" />
            {{ getFacilityAddress() }}
          </a>
        </p>
      </div>
      <hr />
      <div>
        <table class="table no-border border-0">
          <thead>
            <tr>
              <th class="bg-white" scope="col">JOBS</th>
              <th class="bg-white text-center" scope="col">DEPARTMENT</th>
              <th class="bg-white text-center" scope="col">STATUS</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let job of getFacilityJobs()">
              <td data-toggle="tooltip" data-placement="bottom" title="{{ job.name }}">
                <a class="jobs" href="/jobs/{{ job.jobDetail?.id }}" target="_blank">{{ job.jobDetail.number }}</a>
              </td>
              <td class="text-center">{{ job.departmentNumber }}</td>
              <td class="text-center">{{ job.status ? 'Open' : 'Closed' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr />
      <div class="certification-group">
        <p id="certification-title">Certifications required</p>
        <ul *ngFor="let attr of uniqueCertifications" class="list-group">
          <li *ngIf="attr?.status" class="list-group-item bold">
            <span>{{ attr.jobBoardAttribute.name }}</span>
            <span class="expiration-date" *ngIf="attr?.expirationDate"
              >(Exp. {{ formatDate(attr?.expirationDate) }})</span
            >
          </li>
        </ul>
      </div>
      <hr />
      <div class="tags-group">
        <p id="tags-title">TAGS</p>
        <div class="list-group-container">
          <ul class="list-group draggable-box">
            <li *ngFor="let ta of tagAssignments" class="list-group-item">
              <app-job-board-tags
                [removable]="true"
                (delete)="removeCardTag(ta)"
                [tag]="ta?.tag"
                [tagShape]="ta?.tag?.shape"></app-job-board-tags>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="cardData && cardType === 'job'" class="side-bar">
  <div class="side-nav">
    <div class="heading-container px-3 py-2 pt-3">
      <a href="javascript:void(0);" (click)="closeSideNavBar()"
        ><img style="height: 12px; width: 12px" src="/assets/images/icon/close.svg"
      /></a>
    </div>
    <div class="sidenav-container">
      <div>
        <p class="heading-title">
          {{ cardData?.jobNumber }} | {{ cardData?.name }}
          <a href="owner_info/add_edit;id={{ cardData?.jobDetailsId }}" target="_blank"
            ><img src="/assets/images/icon/openFacility.svg"
          /></a>
        </p>
      </div>
      <div>
        <p>
          <a href="https://maps.google.com/?q={{ getJobAddress() }}" target="_blank" class="card-link text-dark bold">
            <img src="/assets/images/icon/location.svg" />
            {{ getJobAddress() }}
          </a>
        </p>
      </div>
      <hr />
      <div>
        <table class="table no-border border-0">
          <thead>
            <tr>
              <th class="bg-white" scope="col">JOBS</th>
              <th class="bg-white text-center" scope="col">DEPARTMENT</th>
              <th class="bg-white text-center" scope="col">STATUS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-toggle="tooltip" data-placement="bottom" title="{{ cardData.jobDetail.name }}">
                <a class="jobs" href="/jobs/{{ cardData.jobDetail?.id }}" target="_blank">{{
                  cardData.jobDetail.number
                }}</a>
              </td>
              <td class="text-center">{{ cardData.departmentNumber }}</td>
              <td class="text-center">{{ cardData.jobDetail.status ? 'Open' : 'Closed' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr />
      <div class="certification-group">
        <p id="certification-title">Certifications required</p>
        <ul *ngFor="let attr of uniqueCertifications" class="list-group">
          <li *ngIf="attr?.status" class="list-group-item bold">
            <span>{{ attr.jobBoardAttribute.name }}</span>
            <span class="expiration-date" *ngIf="attr?.expirationDate"
              >(Exp. {{ formatDate(attr?.expirationDate) }})</span
            >
          </li>
        </ul>
      </div>
      <hr />
      <div class="tags-group">
        <p id="tags-title">TAGS</p>
        <div class="list-group-container">
          <ul class="list-group draggable-box">
            <li *ngFor="let ta of tagAssignments" class="list-group-item">
              <app-job-board-tags
                [removable]="true"
                (delete)="removeCardTag(ta)"
                [tag]="ta?.tag"
                [tagShape]="ta?.tag?.shape"></app-job-board-tags>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
